export default __webpack_public_path__ + "static/bridge-1bda1de4224587564ee2c9e295ea4ebe.jpg";